import { render, staticRenderFns } from "./Quote.vue?vue&type=template&id=7806e158&scoped=true&"
import script from "./Quote.vue?vue&type=script&lang=js&"
export * from "./Quote.vue?vue&type=script&lang=js&"
import style0 from "./Quote.vue?vue&type=style&index=0&id=7806e158&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7806e158",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7806e158')) {
      api.createRecord('7806e158', component.options)
    } else {
      api.reload('7806e158', component.options)
    }
    module.hot.accept("./Quote.vue?vue&type=template&id=7806e158&scoped=true&", function () {
      api.rerender('7806e158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/Quote.vue"
export default component.exports